module.exports = __webpack_public_path__ + "img/wp-new-habit-card16.81e1144c.jpg";